module.exports = __webpack_public_path__ + "img/Site Setback-2.3e7340a0.svg";